import {isVulnerabilityReportsCreation} from "../Authentication/permissions";
import {Button, Checkbox, Modal, Radio, Tooltip, Typography} from "antd";
import {DownloadOutlined} from "@ant-design/icons";
import {capitalize} from "lodash";
import PermissionRoute from "../Authentication/PermissionRoute";
import {useTranslation} from "react-i18next";
import {useDownloadAssetReportOptionsQuery, useLazyDownloadAssetReportQuery} from "../../redux/api/asset";
import {useEffect, useState} from "react";
import {useMessageContext} from "../../context/message/MessageContext";
import {useAssetDetails} from "../../context/assetDetails/AssetDetails";
import OverallImpact from "./cards/hazards/OverallImpact";
import {useHazardSelectionContext} from "../../context/assetDetails/HazardAssetSelectionContext";
import {useGetHazardTypeClassesQuery} from "../../redux/api/hazardTypes";

const VULNERABILITY_CHAPTER = "show_total_vulnerability"

export default function DownloadAssetReport() {

  const {t} = useTranslation()
  const {
    data: chapters,
    isFetching: isFetchingChapters,
    isUninitialized: isUninitializedChapters,
    isSuccess: isSuccessChapters
  } = useDownloadAssetReportOptionsQuery()
  const [download, {isFetching}] = useLazyDownloadAssetReportQuery()
  const {
    data: hazardTypes,
    isFetching: isFetchingHazardTypes,
  } = useGetHazardTypeClassesQuery();
  const setAntdMessage = useMessageContext()
  const [isModalVisible, setIsModalVisible] = useState(false)
  const [type, setType] = useState<'pdf' | 'docx'>('pdf')
  const [selectedChapters, setSelectedChapters] = useState<string[]>([])
  const [, {asset, loading}] = useAssetDetails();

  const closeModal = () => setIsModalVisible(false)
  const openModal = () => setIsModalVisible(true)

  const {
    additionalOptionsGetCalculation,
    checkedList
  } = useHazardSelectionContext()


  const isVulnerabilityReportSelected = selectedChapters.some(el => el === VULNERABILITY_CHAPTER)
  const isVulnerabilityOptionsMissing = ((isVulnerabilityReportSelected && additionalOptionsGetCalculation.isUninitialized) || isFetchingHazardTypes)

  /*
  const handleDownload = () => {
    if (asset.uuid) {
      download({
        assetUuid: asset.uuid,
        out_format: type,
        name: `${t('assets.downloadDetailsFilename')}_${asset.sigi_code}`,
        chapter_flags: selectedChapters,
        ...isVulnerabilityReportSelected && {hazard_types: checkedList as string[]}
      })
        .then(res => {
          setAntdMessage({
            success: capitalize(t('documents.downloadSuccess'))
          })
          closeModal()
        })
        .catch(err => {
          setAntdMessage({
            error: capitalize(t('documents.downloadError'))
          })
        })
    }
  }
  */
  const handleDownload = () => {
  if (asset.uuid) {
    download({
      assetUuid: asset.uuid,
      out_format: type,
      chapter_flags: selectedChapters,
      ...isVulnerabilityReportSelected && {hazard_types: checkedList as string[]},
    })
      .unwrap()
      .then(res => {
        setAntdMessage({
          success: capitalize(t('documents.downloadSuccess'))
        })
        closeModal()
      })
      .catch(err => {
        setAntdMessage({
          error: capitalize(t('documents.downloadError'))
        })
      })
  }
}
  useEffect(() => {
    setSelectedChapters(chapters?.filter(chapter => chapter.default)?.map(chapter => chapter.flag) ?? [])
  }, [chapters]);

  return <PermissionRoute isAuthorized={isVulnerabilityReportsCreation}>
    <Modal
      title={capitalize(t('misc.downloadReport'))}
      open={isModalVisible}
      onCancel={closeModal}
      onOk={handleDownload}
      okButtonProps={{
        disabled: isFetching || isVulnerabilityOptionsMissing,
        loading: isFetching
      }}
    >
      <ol style={{display: 'flex', flexDirection: 'column', gap: 16, margin: '1rem 0', paddingLeft: '1rem'}}>
        <li style={{display: 'flex', flexDirection: 'column', gap: 16}}>
          <Typography.Text italic>
            {capitalize(t('assets.downloadDetailsDescription'))}
          </Typography.Text>
          <div>
            <Radio.Group onChange={(e) => setType(e.target.value)} value={type}>
              <Radio value={'pdf'}>.pdf</Radio>
              <Radio value={'docx'}>.docx</Radio>
            </Radio.Group>
          </div>
        </li>
        <li style={{display: 'flex', flexDirection: 'column', gap: 16}}>
          <Typography.Text italic>
            {capitalize(t('assets.downloadDetailsChapter'))}
          </Typography.Text>
          <Checkbox.Group
            key={+isSuccessChapters}
            disabled={isFetchingChapters || isUninitializedChapters}
            style={{display: 'flex', flexDirection: 'column', gap: 8}}
            value={selectedChapters}
            onChange={values => setSelectedChapters(values as string[])}
          >
            {(chapters ?? []).map(chapter => {
              return <>
                <Checkbox
                  key={chapter.flag}
                  value={chapter.flag}
                >
                  {chapter.description}
                </Checkbox>

              </>
            })}
          </Checkbox.Group>
        </li>
        {selectedChapters.includes(VULNERABILITY_CHAPTER) &&
          <li style={{display: 'flex', flexDirection: 'column', gap: 16}}>
            <Typography.Text italic>
              {(t('assets.downloadDetailsOverallImpactDescription'))}
            </Typography.Text>
            <OverallImpact/>
          </li>}
      </ol>

    </Modal>
    {!asset.position && <Tooltip
      title={capitalize(t('assets.downloadDetailsDisabled'))}
    >
      <Button
        type={"default"}
        style={{width: "100%"}}
        icon={<DownloadOutlined/>}
        disabled={!asset.position}
      >
        {capitalize(t("assets.downloadDetails"))}
      </Button>
    </Tooltip>
    }
    {!!asset.position && <Button
      type={"default"}
      style={{width: "100%"}}
      icon={<DownloadOutlined/>}
      onClick={openModal}
    >
      {capitalize(t("assets.downloadDetails"))}
    </Button>}
  </PermissionRoute>
}